import { Input } from 'antd';
import get from 'lodash/get';

import Button from '~/shared/components/form-fields/button';
import type { ButtonType, FormFieldType } from '~/shared/types/form-type';

export type PatternP4PropsType = {
  submitting: boolean;
  textAlign: string;
  field: string;
  position0: {
    formFields: FormFieldType[];
  };
  position1: {
    formFields: FormFieldType[];
  };
  position2: {
    formFields: FormFieldType[];
  };
  position3: {
    formFields: FormFieldType[];
  };
  position4: {
    formFields: FormFieldType[];
  };
  settings: {
    formFields: FormFieldType[];
  };
  position5: {
    buttons: ButtonType[];
  };
  t: (key: string, options: { ns: string[] }) => string;
};
export const PatternP4 = ({
  submitting,
  position1,
  position0,
  position2,
  position3,
  position4,
  position5,
  field,
}: PatternP4PropsType) => (
  <div className="pattern-p4">
    {position0 && <h2>{get(position0, 'title', '')}</h2>}
    <div>
      {position3 && (
        <div className="pattern-p4__position-block">
          <>
            {get(position3, 'formFields', []).map((item) => {
              const Field = Input;

              return (
                <div className="pattern-p4__form-field-block" key={item.name}>
                  {item.label && <div className="pattern-p4__label">{item.label}</div>}
                  <Field
                    name={field ? `${field}.${item.name}` : item.name}
                    type={item.type}
                    component={Input}
                    label={item.label}
                    {...item.config}
                    validate={item.validate ? item.validate : () => null}
                  />
                </div>
              );
            })}
          </>
        </div>
      )}
      <div>
        <div>
          {position1 && (
            <div className="pattern-p4__position-block">
              <>
                {get(position1, 'formFields', []).map((item) => {
                  const Field = Input;

                  return (
                    <div className="pattern-p4__form-field-block" key={item.name}>
                      {item.label && <div className="pattern-p4__label">{item.label}</div>}
                      <Field
                        name={field ? `${field}.${item.name}` : item.name}
                        type={item.type}
                        component={Input}
                        label={item.label}
                        {...item.config}
                        validate={item.validate ? item.validate : () => null}
                      />
                    </div>
                  );
                })}
                {get(position1, 'buttons', []).map((item, index) => (
                  <Button
                    key={index}
                    className="extra-small invert"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                  >
                    {item.buttonName}
                  </Button>
                ))}
              </>
            </div>
          )}
          {position2 && (
            <div className="pattern-p4__position-block">
              {get(position2, 'formFields', []).map((item) => {
                const Field = Input;

                return (
                  <div className="pattern-p4__form-field-block" key={item.name}>
                    {item.label && <div className="pattern-p4__label">{item.label}</div>}
                    <Field
                      name={field ? `${field}.${item.name}` : item.name}
                      type={item.type}
                      component={Input}
                      label={item.label}
                      {...item.config}
                      validate={item.validate ? item.validate : () => null}
                    />
                  </div>
                );
              })}
              {get(position2, 'buttons', []).map((item, index) => (
                <Button
                  key={index}
                  className="extra-small invert"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  {item.buttonName}
                </Button>
              ))}
            </div>
          )}
        </div>
        {position4 && (
          <div className="pattern-p4__position-block">
            {get(position4, 'formFields', []).map((item) => {
              const Field = Input;

              return (
                <div className="pattern-p4__form-field-block" key={item.name}>
                  {item.label && <div className="pattern-p4__label">{item.label}</div>}
                  <Field
                    name={field ? `${field}.${item.name}` : item.name}
                    component={Input}
                    type={item.type}
                    label={item.label}
                    {...item.config}
                    validate={item.validate ? item.validate : () => null}
                  />
                </div>
              );
            })}
            {get(position4, 'buttons', []).map((item, index) => (
              <Button
                key={index}
                className="extra-small invert"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                {item.buttonName}
              </Button>
            ))}
          </div>
        )}
        {position5 && (
          <>
            <div className="pattern-p4__position-block">
              {get(position5, 'buttons', []).map((item, index) => (
                <Button
                  key={index}
                  className="extra-small invert"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  {item.buttonName}
                </Button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  </div>
);
